import  React from  'react';
import  Grid  from  '@mui/material/Grid';
import  Box  from  '@mui/material/Box';
import  Paper  from  '@mui/material/Paper';
import  Avatar  from  '../Avatar';
import  logo  from  '../../assets/png/logo192.png';
import  './auth.css';
const   Container   =     React.forwardRef((props, ref) => {
    return  <Grid ref={ref} className="auth-content">
              <Paper>
                <Grid align="center">
                  <Avatar sx={{width:150,height:150,border:"solid 3px #fff", mt:-10}} title="Programandoweb" alt="" src={logo}/>
                </Grid>
                <Box component={props.onSubmit?"form":""} noValidate={props.noValidate||false} autoComplete="off" onSubmit={props.onSubmit}>
                  <Grid className={props.className||"auth-form"}>
                    {props.children}
                  </Grid>
                </Box>
              </Paper>
            </Grid>
});


export default Container
//#fb19ff
